import { updateOffice, getOffices } from "../api/officeService";

export const useUpdateOffice = (setOffices) => {
    const update = async (id, data) => {
        try {
            const updatedOffice = await updateOffice(id, data);
            const officesResponse = await getOffices();
            setOffices(officesResponse);
            return updatedOffice;
        } catch (error) {
            console.error("Failed to update office:", error);
            throw error;
        }
    };

  return { update };
};